module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.4d9f3f9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.eot
// module id = 197
// module chunks = 1